export default __webpack_public_path__ + "static/media/location.08194cba.svg";